/** Shared class strings for this microsite's type ramp, so the pages can't drift apart. */
export const MONO_MICRO =
  'font-[family-name:var(--font-vr-mono)] text-[10px] uppercase leading-[1.4] tracking-[0.1em]'
export const MONO_KICKER =
  'font-[family-name:var(--font-vr-mono)] text-[11px] font-medium uppercase leading-[1.2] tracking-[0.14em]'
export const MONO_LABEL =
  'font-[family-name:var(--font-vr-mono)] text-[12px] uppercase leading-[1.4] tracking-[0.08em]'
export const MONO_SPEC =
  'font-[family-name:var(--font-vr-mono)] text-[12px] leading-[1.7] tracking-[0.02em]'
export const DISPLAY = 'font-[family-name:var(--font-vr-display)] font-medium'
export const DISPLAY_LIGHT = 'font-[family-name:var(--font-vr-display)] font-light'

/** VR/Display XL - the page-owning headline. 425 / 768 / 1440 boards. */
export const DISPLAY_XL =
  'text-[52px] leading-[0.95] tracking-[-0.03em] md:text-[72px] xl:text-[96px]'
/** VR/Display L - the register page's headline. 425 / 768 / 1440 boards. */
export const DISPLAY_L =
  'text-[40px] leading-[0.95] tracking-[-0.03em] md:text-[64px] xl:text-[72px]'
/** VR/Display XXS - 36px, the mobile menu's destinations. */
export const DISPLAY_XXS = 'text-[36px] leading-[0.95] tracking-[-0.03em]'
/** VR/Display M - the gate's "You were sent an access code." */
export const DISPLAY_M = 'text-[34px] leading-[1] tracking-[-0.02em] md:text-[44px] xl:text-[56px]'
/** VR/Body L / M / S - 18 / 16 / 14px. Pair with `md:text-[18px]` where a board steps M up. */
export const BODY_L = 'text-[18px] leading-[1.6]'
export const BODY_M = 'text-[16px] leading-[1.6]'
export const BODY_S = 'text-[14px] leading-[1.55]'
/** VR/Heading L - 40px, the size every section title uses. Stepped down on small screens. */
export const HEADING_L = 'text-[32px] leading-[1.05] tracking-[-0.02em] md:text-[40px]'
/** VR/Heading M - 28px */
export const HEADING_M = 'text-[24px] leading-[1.1] tracking-[-0.01em] md:text-[28px]'

/*
 * Two colours have no token: ground #020304 and ground-raised #0a0c0d. They appear as literal hex
 * inside arbitrary classes (`bg-[#020304]`) rather than as constants, because Tailwind has to see
 * the literal at build time to emit the utility - a constant would compile to nothing.
 *
 * They are deliberately NOT added to tailwind.config.mjs: this is an off-brand, temporary
 * campaign, and its palette should not outlive it in the shared design system. Aurora and cloud
 * DO have real tokens (civo-lime, civo-cloud), the denied red is Tailwind's red-500, and the
 * enquiry form's CSS module carries that as #ef4444 because a module cannot use a utility class.
 */

/** The container every full-width section shares. */
export const CONTAINER = 'mx-auto max-w-[1440px] px-7 md:px-9 xl:px-16'
